import crypto from 'crypto';
import { getHeaders } from '~/utils/urlHelpers'
export default defineNuxtPlugin(nuxtApp => {

  const dataAll = useDataAll()
  const runtimeConfig = useRuntimeConfig();
  const { isIntranet, goToLoginPageFrontendIntranet } = useIntranetAuth()
  const $helpers = useNuxtApp().$helpers;
  if (!$helpers) {
    throw new Error('Global $helpers is not available. Did you forget to register functionsGlobal.js plugin?');
  }

  const apiMethods = {
    allow404: false,


    async loadJSONApi(url) {
      return apiMethods.handleApiCall(url, 'GET')
    },

    async postApiCall(url, params) {
      return apiMethods.handleApiCall(url, 'POST', params)
    },

    async handleApiCall(url, postGet, params) {
      if (!url) return false;
      let returnValue = false;

      try {
        
 
        await $fetch(url, {
          headers: getHeaders(),
          method: postGet,
          body: params,
          onResponse({ request, response, options }) {
            if (response.status == 404 && apiMethods.allow404) {
              apiMethods.allow404 = false
              let errorMsg = "File not found  " + url
              console.log(errorMsg)
            } else if (typeof response._data !== "object") {
              let errorMsg = "ERROR response no JSON: " + url
              dataAll.setDataVar('errorStringLoad', errorMsg)
            } else {
              returnValue = response._data;
            }
          },
          onResponseError({ request, response, options }) {
            if (response.status == 401) {           
              if (isIntranet()){
                navigateTo(goToLoginPageFrontendIntranet())
              }
              return false;
            } else {
              console.log('error response')
            }
          },
        })
      } catch (error) {
        console.log(error)
      }

      return returnValue;
    },

    async handleApiCallDownload(urlLoad, postGet, params) {
      try {
        const response = await fetch(urlLoad, {
          method: postGet,
          headers: {
            'Content-Type': 'application/json',
            ...getHeaders(),
          },
          body: JSON.stringify(params),
        });
        if (!response.ok) {
          const errorResponse = await response.json();
          throw new Error(errorResponse && errorResponse.message ? errorResponse.message : "Unknown error");
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', params.path.split('/').pop());
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        alert(error);
      }
    },

    generateSecurityParameters() {
      if (import.meta.server) {
        const timestamp = Math.floor(Date.now() / 1000);
        dataAll.setDataVar("tsLastLoadedServer", Math.floor(Date.now() / 1000));
        const hash = crypto
          .createHmac('sha256', runtimeConfig.SECRET_CLIENT_API_HASH)
          .update(`${timestamp}:rnb2@encbaFjwhe`)
          .digest('hex');
        // const hash = 'test' // todo weghalen verbeteren.
        dataAll.setDataVar("tsHash", hash);
      }
    },

    addSecurityparams(params) {
      params.timestamp = dataAll.getDataVar("tsLastLoadedServer");
      params.hash = dataAll.getDataVar("tsHash");
      return params
    },

    getCacheLink(link) {
      const labelId = $helpers.getLabelId();
      const language = dataAll.getLanguage().toLowerCase();
      if ((typeof (process) != "undefined" && process !== null) && import.meta.server) {
        return `${runtimeConfig.public.SERVER_HOST_PROTOCOL}://${dataAll.getDataVar('hostname')}/cache/JSON/${labelId}/${language}_${link}`;
      } else {
        return `/cache/JSON/${labelId}/${language}_${link}`;
      }
    },

    getApiHostUrl() {
      if ((typeof (process) != "undefined" && process !== null) && import.meta.server) {
        return runtimeConfig.public.APIURL_SERVERSIDE
      } else {
        if (runtimeConfig.public.TESTAPIURLCLIENTSIDE == 0) {
          return "https://" + dataAll.getDataVar('hostname');
        } else {
          return runtimeConfig.public.TESTAPIURLCLIENTSIDE
        }
      }
    },

    getLinkFromPageItem(pageItem) {
      var url = '';
      if (!pageItem || !$helpers.isset(pageItem)) {
        return url;
      }

      if (runtimeConfig.public.JSON_FROM_CACHE == 1) {
        return apiMethods.getCacheLink(pageItem.Code + ".json");
      } else {
        return apiMethods.getApiHostUrl() + "/api/" + $helpers.getLabelId() + "/custom/" + dataAll.getLanguage() + "/" + pageItem.Code
      }
    },

    getLinkFromtNewsEventvacancyItem(type, item) {
      return runtimeConfig.public.JSON_FROM_CACHE == 1
        ? apiMethods.getCacheLink(`${type}_${item}.json`)
        : `${apiMethods.getApiHostUrl()}/api/${$helpers.getLabelId()}/${type}/${dataAll.getLanguage().toUpperCase()}/${item}`;
    },

    getOverviewNewsEventvacancyItem(type) {
      apiMethods.allow404 = true;
      return runtimeConfig.public.JSON_FROM_CACHE == 1
        ? apiMethods.getCacheLink(`${type}.json`)
        : `${apiMethods.getApiHostUrl()}/api/${$helpers.getLabelId()}/${type}/${dataAll.getLanguage().toUpperCase()}`;
    },
  };

  nuxtApp.provide('apiMethods', apiMethods);
});
